import { render, staticRenderFns } from "./changeInfo.vue?vue&type=template&id=cf4c2864&scoped=true&"
import script from "./changeInfo.vue?vue&type=script&lang=js&"
export * from "./changeInfo.vue?vue&type=script&lang=js&"
import style0 from "./changeInfo.vue?vue&type=style&index=0&id=cf4c2864&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4c2864",
  null
  
)

export default component.exports